export default __webpack_public_path__ + "static/media/icon_9_on.1e8894cc.png";